<template>
  <div v-if="items">
    <section id="know">
      <KnowIntro :know_section="items.know_section"></KnowIntro>
    </section>

    <section id="strengths">
      <UpstanderStrengths :case_studies="items.related_case_studies" :profiles="items.related_upstander_profiles" ></UpstanderStrengths>
    </section>

    <section id="take_a_stand">
      <PersonalStrengths ></PersonalStrengths>
    </section>
  </div>
</template>

<script>
import KnowIntro from '@/components/know/KnowIntro'
import PersonalStrengths from '@/components/know/PersonalStrengths'
import UpstanderStrengths from '@/components/know/UpstanderStrengths'

export default {
  name: 'Know',
  components: {
    KnowIntro,
    PersonalStrengths,
    UpstanderStrengths
  },
  props: [
    'items',
  ]
}
</script>